import { Typography } from '@mui/material'

import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'

type TermsAndServiceProps = {
  landingPage?: boolean
}

export const TermsAndService = ({ landingPage }: TermsAndServiceProps) => (
  <Typography
    variant="p4"
    textAlign={landingPage ? 'left' : 'center'}
    color={Color.saint.lightest}
    margin="0 0 30px 0"
    fontSize="12px"
  >
    By continuing, you agree to our{' '}
    <Anchor href="/privacy" variant="p4" fontSize="12px" fontWeight="400" rel={undefined} external>
      Privacy Policy
    </Anchor>{' '}
    and{' '}
    <Anchor
      href="/terms-of-service"
      variant="p4"
      fontSize="12px"
      fontWeight="400"
      rel={undefined}
      external
    >
      Terms of Service
    </Anchor>
    {landingPage ? ', including our arbitration provision.' : '.'}
  </Typography>
)

export default TermsAndService
